import React from "react";
import Body from "./components/body";
import Sidebar from "./components/sidebar";

function App() {
  return (
    <div className="h-screen bg-zinc-950 text-zinc-100 font-sans relative overflow-hidden flex items-center justify-center py-4 sm:py-8 px-4 sm:px-6 lg:px-8">
      {/* Dynamic background glow blobs */}
      <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] rounded-full bg-violet-900/10 blur-[120px] pointer-events-none animate-pulse-slow"></div>
      <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-cyan-900/10 blur-[120px] pointer-events-none animate-pulse-slow"></div>

      {/* Subtle grid pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1f293708_1px,transparent_1px),linear-gradient(to_bottom,#1f293708_1px,transparent_1px)] bg-[size:24px_24px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] pointer-events-none"></div>

      <main className="w-full max-w-7xl mx-auto h-[calc(100vh-2rem)] sm:h-[calc(100vh-4rem)] flex flex-col lg:grid lg:grid-cols-12 gap-6 lg:gap-8 relative z-10">
        <div className="lg:col-span-3 w-full animate-fade-in flex flex-col shrink-0 lg:h-full">
          <Sidebar />
        </div>
        <div className="lg:col-span-9 w-full animate-slide-up flex flex-col min-h-0 flex-1 lg:h-full">
          <Body />
        </div>
      </main>
    </div>
  );
}

export default App;
